module.exports = __webpack_public_path__ + "img/zoom2.e248008f.png";